export const CONSTS = {
  HEADER: $localize`Select`,
};
